import { useDispatch, useSelector } from 'react-redux'
import Pagination from 'components/pagination/Pagination'
import { setCampaignsPage } from 'features/crux/tracker/detail/trackerDetailSlice'
import Table from 'components/table/Table'
import classNames from 'classnames'
import { useHistory, useParams } from 'react-router-dom'
import NoneAnchor from 'components/NoneAnchor'

const Campaigns = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { accountId: adAccountId } = useParams()
  const { content, isLoading, page, totalElements } = useSelector(
    state => state.tracker.detail.campaigns
  )
  return (
    <div className="audience_detail">
      <div className="tbl_top">
        <p className="txt_noti">
          해당 픽셀 &amp; SDK를 사용중인 캠페인을 확인할 수 있습니다.
        </p>
      </div>
      <div className="tblg2_wrap">
        <Table
          className="tbl_g2"
          caption="캠페인 표"
          loading={isLoading}
          emptyMessage="연동 중인 캠페인이 없습니다.">
          <Table.Head>
            <Table.Column title="캠페인" />
            <Table.Column title="캠페인 상태" width={235} />
          </Table.Head>
          <Table.Body>
            {content.map(({ id, name, status }) => (
              <Table.Row key={id} rowId={id}>
                <td>
                  <div className="inner_tbl">
                    <span className="limit_line">
                      <NoneAnchor
                        onClick={() =>
                          history.push(
                            `/${adAccountId}/gotoDashboard?campaignId=${id}`
                          )
                        }
                        className="link_txt limit_line">
                        {name}
                      </NoneAnchor>
                    </span>
                  </div>
                </td>
                <td>
                  <div className="inner_tbl">
                    <p className="ad_state ico_state">
                      <span
                        className={classNames({
                          ico_on: status === 'ON',
                          ico_off: status === 'OFF',
                        })}>
                        {status}
                      </span>
                      {status === 'ON' ? '운영 가능' : '운영 불가(OFF)'}
                    </p>
                  </div>
                </td>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </div>
      {totalElements > 0 && (
        <div className="paging_wrap">
          <div className="inner_paging">
            <Pagination
              current={page}
              total={totalElements}
              onChange={v => dispatch(setCampaignsPage(v))}
            />
          </div>
        </div>
      )}
    </div>
  )
}
export default Campaigns
